import {
  Form,
  Select,
  Spin,
  Table,
  Tooltip,
  message,
} from "antd";
import React, { Component } from "react";

import Api from "../../helpers/apiHandler";
import Button from "../../components/uielements/button";
import Delete from "../../components/modals/delete";
import { connect } from "react-redux";
import { TableStyleWrapper } from "../../components/utility/table.style";
import {
  formatDateWithContext,
} from "../../helpers/utility";
import awsPaths, { basePath } from "../../helpers/awsPaths";
import ConfirmModal from "../../components/modals/confirmModal";

const api = new Api();

const FormItem = Form.Item;
const Option = Select.Option;
let sortBy = {
  direction: "DESC",
  property: "date_created",
};
let filterData = null;
let searchText = "";

const s3ImageFlag = "safetyFileThumb";
const s3FileFlag = "safetyFile";

export class CommunitySafetyDataSheet extends Component {
  state = {
    recordToDelete: 0,
    CommunitySafetyDataSheetList: [],
    uploadInDataSheetModal: false,
    addFormType: undefined,
    addFormDocumentList: [],
    isConfirmLoading: false,
    confirmModalVisible: false,
    deleteModalVisible: false,
    deleteLoading: false,
    manufactureList: [],
    isManufactureLoading: false,
    isIngredientLoading: false,
    ingredientList: [],
    iFilterManufactureId: 0,
    iFilterIngredientId: 0,
    iUploadDocId: 0,
    ingredientId: 0,
    manufacturerId: 0,
    fileUploadLoader: false,
    recordToDelete: 0,
    deleteDataSheetId: 0,
    pageData: {
      pageSize: 10,
      current: 1,
      total: 0,
    },
    selectedRowKeys: [],
    selectedRows: [],
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, selectedRows });
  };

  getManufactureList = () => {
    this.setState({ isManufactureLoading: true });

    api
      .get("common/manufacturer/list")
      .then((response) => {
        if (response.status === 1) {
          const manufacturerData = response.data;

          this.setState({
            manufactureList: manufacturerData,
            isManufactureLoading: false,
          });
        } else {
          // console.log("!200");
        }
      })
      .catch((error) => {
        console.error("Failed to fetch manufacturers:", error);
        this.setState({ isManufactureLoading: false });
      });
  };

  getIngredientList = (id) => {
    this.setState({
      isIngredientLoading: true,
      ingredientList: [],
    });

    const manufacturer_id = id ? id : 0;

    api
      .get(`common/product/list/${manufacturer_id}`)
      .then((response) => {
        if (response.status === 1) {
          let ingredientData = response.data;
          this.setState({
            ingredientList: ingredientData,
            isIngredientLoading: false,
          });
        } else {
          // console.log("!200");
        }
      })
      .catch((error) => {
        this.setState({ ingredientList: [], isIngredientLoading: false });
        return error;
      });
  };

  componentDidMount() {
    this.getManufactureList();
    this.getIngredientList(this.state.iFilterManufactureId || 0);
    this.getCommunitySafetyDataSheetData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.iFilterManufactureId !== prevState.iFilterManufactureId) {
      this.getIngredientList(this.state.iFilterManufactureId || 0);
    }
    if (
      this.state.iFilterManufactureId !== prevState.iFilterManufactureId ||
      this.state.iFilterIngredientId !== prevState.iFilterIngredientId
    ) {
      this.getCommunitySafetyDataSheetData();
    }

    if (this.state.pageData.current !== prevState.pageData.current) {
      this.getCommunitySafetyDataSheetData();
    }
  }

  async getCommunitySafetyDataSheetData() {
    const parameters = {
      page: {
        limit: this.state.pageData.pageSize,
        pageId: this.state.pageData.current - 1,
      },
      order: sortBy ? sortBy.direction : "DESC",
      orderBy: sortBy ? sortBy.property : "date_created",
      sortBy: sortBy,
      query: searchText,
      companyId: this.props.auth.company.id,
      filters: {
        ingredientId: this.state.iFilterIngredientId,
        manufacturerId: this.state.iFilterManufactureId,
      },
    };

    this.setState({
      loading: true,
    });

    await api
      .post("common/safety/global/datasheet/list", {
        isMultipart: false,
        data: parameters,
      })
      .then((response) => {
        this.setState({
          loading: false,
        });

        if (response.status === 1) {
          let CommunitySafetyDataSheetList = response.data.list;

          this.setState({
            pageData: {
              total: response.data.totalRecords,
              pageSize: this.state.pageData.pageSize,
              current: this.state.pageData.current,
            },
          });

          this.setState({
            CommunitySafetyDataSheetList: CommunitySafetyDataSheetList,
          });
        } else {
          // console.log("!200");
        }
      })
      .catch((error) => {
        return error;
      });
  }

  handleTableChange = (pagination, filters, sorter) => {
    if ("columnKey" in sorter) {
      sortBy = {
        property: "date_created",
        direction: sorter.order === "descend" ? "DESC" : "ASC",
      };
    } else {
      sortBy = null;
    }
    this.setState({
      pageData: pagination,
    });
    this.getCommunitySafetyDataSheetData();
  };

  onSearchTable(value, event) {
    searchText = value;
    this.getCommunitySafetyDataSheetData();
  }

  handleUploadAddCancel = () => {
    this.setState({
      uploadInDataSheetModal: false,
    });
  };

  handleFileUpload = (fileData) => {
    this.setState({
      addFormDocumentList: fileData,
    });
  };

  deleteSuccess = async () => {
    this.setState({
      deleteLoading: true,
    });
    await api
      .delete(
        "common/safety/datasheet/delete-safety-datasheet/" +
          this.state.deleteDataSheetId,
        {}
      )
      .then((response) => {
        this.setState({
          deleteModalVisible: false,
          deleteDataSheetId: 0,
          deleteLoading: false,
        });
        if (response.status === 1) {
          message.success(response.message);
          this.getCommunitySafetyDataSheetData();
        } else {
          // console.log("!200");
        }
      })
      .catch((error) => {
        return error;
      });
  };

  deleteCancel = () => {
    this.setState({
      deleteModalVisible: false,
      deleteDataSheetId: 0,
    });
  };

  confirmSuccess = async () => {
    const parametersList = this.state.selectedRows.map((record) => ({
      filePath: record.file || "",
      companyId: this.props.auth.company.id || 0,
      usedBy: this.props.auth.company.id || "",
      type: record.type || "",
      uploadedBy: this.props.auth.id || "",
      manufacturerId: record.manufacturer.id || "",
      ingredientId: record.product.id || "",
      isShareWithCommunity: this.state.isShareWithCommunity || false,
      isGlobal: true,
    }));

    this.setState({
      isConfirmLoading: true,
    });

    await api
      .post("common/safety/datasheet/transfer", {
        isMultipart: false,
        data: parametersList,
      })
      .then(async (response) => {
        if (response.status === 1) {
          message.success("Data Sheet transfer successfully");
        } else {
          message.error(
            response.message
              ? response.message
              : "Error occurred while transferring the Safety Data Sheet."
          );
          // console.log("!200");
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        this.setState({ confirmModalVisible: false, isConfirmLoading: false });
      });
  };

  confirmCancel = () => {
    this.setState({
      confirmModalVisible: false,
    });
  };

  render() {
    const { getFieldDecorator, validateFieldsAndScroll, resetFields } =
      this.props.form;

    const columns = [
      {
        title: "Manufacturer",
        dataIndex: "manufacture",
        key: "manufacture",
        render: (text, record) => <div>{record.manufactureName}</div>,
      },
      {
        title: "Chemical / Product",
        dataIndex: "product",
        key: "product",
        render: (text, record) => <div>{record.productName}</div>,
      },
      {
        title: "Uploaded By",
        dataIndex: "uploadedByName",
        key: "uploadedByName",
      },
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
        render: (text, record) => (
          <Button
            size="small"
            onClick={() => {
              window.open(`${basePath}/${awsPaths[s3FileFlag]}/${record.file}`);
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: "Created At",
        dataIndex: "createdAt",
        key: "createdAt",
        sorter: true,
        render: (text) => (text ? formatDateWithContext(text) : "--"),
      },
      // {
      //   title: "Action",
      //   key: "action",
      //   width: 80,
      //   render: (text, record) => (
      //     <div className="display-flex gap-6px">
      //       <Tooltip placement="top" title={"Transfer"}>
      //         <Button
      //           icon="swap"
      //           className="viewButton"
      //           size="small"
      //           onClick={() => {
      //             this.setState(() => ({
      //               confirmModalVisible: true,
      //             }));
      //           }}
      //         />
      //       </Tooltip>
      //     </div>
      //   ),
      //   fixed: "right",
      // },
    ];

    return (
      <div style={{ border: "none", marginTop: "10px" }}>
        <div
          className="display-flex justify-space-between align-center"
          style={{ marginBottom: "10px" }}
        >
          <div className="display-flex align-center gap-12px">
            <Select
              allowClear
              showSearch
              style={{ width: 300 }}
              placeholder="Select Manufacturer"
              optionFilterProp="children"
              onChange={(value) => {
                this.setState({
                  iFilterManufactureId: value,
                });
              }}
              loading={this.state.isManufactureLoading}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.state.isManufactureLoading && (
                <Option key="loading" disabled>
                  <Spin size="small" />
                </Option>
              )}

              {!this.state.isManufactureLoading &&
                this.state.manufactureList.map((curItem, index) => {
                  return (
                    <Option key={index} value={curItem.id}>
                      {curItem.name}
                    </Option>
                  );
                })}
            </Select>

            <Select
              allowClear
              showSearch
              style={{ width: 300 }}
              placeholder="Select Chemical / Product"
              optionFilterProp="children"
              onChange={(value) => {
                this.setState({
                  iFilterIngredientId: value,
                });
              }}
              loading={this.state.isIngredientLoading}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.state.isIngredientLoading && (
                <Option key="loading" disabled>
                  <Spin size="small" />
                </Option>
              )}

              {!this.state.isIngredientLoading &&
                this.state.ingredientList.map((curItem, index) => {
                  return (
                    <Option key={index} value={curItem.id}>
                      {curItem.name}
                    </Option>
                  );
                })}
            </Select>
          </div>

          <Button
            type="primary"
            onClick={() => {
              if (
                this.state.selectedRows &&
                this.state.selectedRows.length > 0
              ) {
                this.setState(() => ({
                  confirmModalVisible: true,
                }));
              } else {
                message.error(
                  "Please select at least one Safety Data Sheet to transfer."
                );
              }
            }}
          >
            Transfer Safety Data Sheet
          </Button>
        </div>

        <br />
        <TableStyleWrapper>
          <Table
            dataSource={this.state.CommunitySafetyDataSheetList}
            columns={columns}
            scroll={{
              x: true,
            }}
            className="isoSortingTable"
            pagination={this.state.pageData}
            loading={this.state.loading}
            onChange={this.handleTableChange}
            rowSelection={{
              selectedRowKeys: this.state.selectedRowKeys,
              onChange: this.onSelectChange,
            }}
            onRow={(record) => ({
              onClick: () => {
                window.open(`${basePath}/${awsPaths[s3FileFlag]}/${record.file}`);
              },
              style: { cursor: 'pointer' }
            })}
          />
        </TableStyleWrapper>

        <Delete
          visible={this.state.deleteModalVisible}
          closeDeletePopup={this.deleteCancel}
          confirmDelete={this.deleteSuccess}
          deleteButtonLoading={this.state.deleteLoading}
          message="Are you sure you want to delete safety data?"
        />

        <ConfirmModal
          loading={this.state.isConfirmLoading}
          visible={this.state.confirmModalVisible}
          handleSuccess={this.confirmSuccess}
          handleCancel={this.confirmCancel}
          title="Transfer Safety Data Sheet"
          description="Are you sure you want to add this Safety Data Sheet to your company's database of Safety Data Sheets?"
          okText="Confirm"
          cancelText="Cancel"
        />
      </div>
    );
  }
}

const WrappedCompany = Form.create()(
  connect((state) => ({ auth: state.Auth }))(CommunitySafetyDataSheet)
);

export default WrappedCompany;
